(function () {
  'use strict';

  var routes = (window.FoxTheme && window.FoxTheme.routes) || {};
  var ADD = routes.cart_add_url || '/cart/add';
  var UPDATE = routes.cart_update_url || '/cart/update';
  var CART = (routes.cart_url || '/cart') + '.js';

  var ADDONS_NESTED = false;

  function groupId() {
    return 'ao-' + Math.random().toString(36).slice(2, 10) + '-' + String(Date.now()).slice(-6);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function init(block) {
    if (block.__wbAddons) return;
    block.__wbAddons = true;

    var grid = block.querySelector('[data-wb-ao-grid]');
    var panel = block.querySelector('[data-wb-ao-panel]');
    var list = block.querySelector('[data-wb-ao-list]');
    var count = block.querySelector('[data-wb-ao-count]');
    var form = document.getElementById(block.getAttribute('data-form'));
    if (!grid || !form || !panel || !list) return;

    var t = function (k, d) { return panel.getAttribute('data-t-' + k) || d; };
    var tRemove = t('remove', 'Remove'), tView = t('view', ''), tNewWin = t('newwin', '');
    var tEach = t('each', '# each'), tQty = t('qty', 'Quantity');

    /* ---- the catalogue: every purchasable variant this block can add ----
       Built once from the tiles. A plain tile is one member; a group tile
       carries its members as JSON. Everything downstream — the panel, the
       totals, the submit — reads from here, never from the tiles again. */
    var cat = Object.create(null);          // variant id -> member (+ .group, .tile)
    var groups = Object.create(null);       // group key -> { tile, members[], def }
    var tiles = grid.querySelectorAll('[data-wb-ao-add]');
    for (var i = 0; i < tiles.length; i++) {
      var b = tiles[i];
      var tile = b.closest('[data-wb-ao]');
      var raw = b.getAttribute('data-members');
      if (raw) {
        var members;
        /* Liquid emits the members as comma-joined objects; the brackets go on here */
        try { members = JSON.parse('[' + raw + ']'); } catch (e) { members = []; }
        var key = tile.getAttribute('data-group');
        var def = b.getAttribute('data-default') || (members[0] && members[0].id);
        groups[key] = { tile: tile, btn: b, members: members, def: String(def),
                        name: b.getAttribute('data-title') };
        for (var j = 0; j < members.length; j++) {
          var m = members[j];
          m.id = String(m.id); m.group = key; m.tile = tile;
          m.tLess = b.getAttribute('data-t-less'); m.tMore = b.getAttribute('data-t-more');
          cat[m.id] = m;
        }
      } else {
        var id = b.getAttribute('data-variant');
        cat[id] = {
          id: id, price: parseInt(b.getAttribute('data-price'), 10) || 0,
          money: b.getAttribute('data-money'), title: b.getAttribute('data-title'),
          label: null, reason: b.getAttribute('data-reason'), img: b.getAttribute('data-img'),
          url: b.getAttribute('data-url'),
          min: parseInt(b.getAttribute('data-min'), 10) || 1,
          step: parseInt(b.getAttribute('data-step'), 10) || 1,
          tile: tile, group: null,
          tLess: b.getAttribute('data-t-less'), tMore: b.getAttribute('data-t-more')
        };
      }
    }

    for (var q = 0; q < tiles.length; q++) tiles[q].__wbLabel = tiles[q].getAttribute('aria-label') || '';
    var tAdded = count ? (count.getAttribute('data-added') || '# added') : '# added';

    var chosen = Object.create(null);       // variant id -> qty
    /* ONE card open at a time (Owen, 2026-09-12: two group cards stacked put
       the second one under the fold). `active` is the tile whose card the
       panel shows — a group key or a variant id — or null for no card. Every
       other ticked tile shows its count in the corner badge instead. */
    var active = null;

    function tileKey(tile) {
      var b = tile.querySelector('[data-wb-ao-add]');
      return tile.getAttribute('data-group') || (b && b.getAttribute('data-variant'));
    }
    /* units ticked under one tile: the qty of a plain tile, the sum of a group's sizes */
    function tileUnits(key) {
      var g = groups[key];
      if (!g) return chosen[key] || 0;
      var u = 0;
      for (var i = 0; i < g.members.length; i++) u += chosen[g.members[i].id] || 0;
      return u;
    }
    function tileButton(key) {
      var g = groups[key];
      if (g) return g.btn;
      return cat[key] && cat[key].tile ? cat[key].tile.querySelector('[data-wb-ao-add]') : null;
    }
    function clearTile(key) {
      var g = groups[key];
      if (g) { for (var i = 0; i < g.members.length; i++) delete chosen[g.members[i].id]; }
      else delete chosen[key];
      if (active === key) active = null;
    }

    var ctaText = form.querySelector('[data-wb-cta-text]');
    var qtyField = form.querySelector('[name="quantity"]');
    var ctaBase = ctaText ? ctaText.textContent.trim() : '';
    var ctaMulti = block.getAttribute('data-cta-multi') || '';

    function parentQty() {
      var n = parseInt(qtyField && qtyField.value, 10);
      return n > 0 ? n : 1;
    }
    function units() { var u = 0; for (var k in chosen) if (chosen[k]) u += chosen[k]; return u; }
    function cents() { var c = 0; for (var k in chosen) if (chosen[k] && cat[k]) c += cat[k].price * chosen[k]; return c; }

    /* UNITS, the same number the badges add up to and the CTA counts —
       three readouts of one selection must not use three bases. */
    function paintCount() {
      if (!count) return;
      var n = units();
      count.textContent = n
        ? (count.getAttribute('data-added') || '# added').replace('#', n)
        : (count.getAttribute('data-optional') || count.textContent);
    }

    function paintCta() {
      if (ctaText && ctaMulti) {
        var u = units();
        ctaText.textContent = u ? ctaMulti.replace('#', parentQty() + u) : ctaBase;
      }
      document.dispatchEvent(new CustomEvent('wb:addons:change', {
        detail: { units: units(), cents: cents() }
      }));
    }

    /* is-in = ticked: the corner mark becomes a badge with the count (the
       "1 alert" Owen asked for), so a tile whose card is closed still says
       what it holds. is-on = the tile whose card is open (navy border). */
    function paintTiles() {
      for (var i = 0; i < tiles.length; i++) {
        var b = tiles[i], tile = b.closest('[data-wb-ao]');
        var key = tileKey(tile);
        var n = tileUnits(key);
        var open = n > 0 && active === key;
        tile.classList.toggle('is-in', n > 0);
        tile.classList.toggle('is-on', open);
        b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        var mark = tile.querySelector('.wb-ao__mark');
        if (mark) mark.textContent = n > 0 ? String(n) : '\u2713';
        /* the badge is aria-hidden; the number rides on the label instead */
        b.setAttribute('aria-label', n > 0 ? b.__wbLabel + ', ' + tAdded.replace('#', n) : b.__wbLabel);
      }
    }

    /* Round UP to the next quantity the product allows — never down; a
       shopper who typed 5 wants at least 5 (same rule as the PDP stepper). */
    function roundUpTo(m, n) {
      var min = m.min || 1, step = m.step || 1;
      if (n < min) return min;
      var over = (n - min) % step;
      return over ? n + (step - over) : n;
    }

    /* − [typed number] +. The readout is a real input (Owen, 2026-09-15:
       "not allowing the user to manually type a number") — it looks like the
       PDP stepper, so people type into it. Typing commits as you go while the
       number is one the product allows; anything else settles on blur (rounded
       up, or the size removed when it reads 0). The in-place refresh leaves
       the field alone while it has focus, so typing "12" is never fought. */
    function stepper(m, onZero) {
      var id = m.id;
      var st = el('span', 'wb-aop__step');
      var minus = el('button', null, '−'); minus.type = 'button';
      minus.setAttribute('aria-label', m.tLess || 'Less');
      var field = document.createElement('input');
      field.type = 'number'; field.className = 'wb-aop__qty'; field.inputMode = 'numeric';
      field.min = '0'; field.step = String(m.step || 1);
      field.value = String(chosen[id] || 0);
      field.setAttribute('aria-label', tQty + (m.label ? ' – ' + m.label : ''));
      var plus = el('button', null, '+'); plus.type = 'button';
      plus.setAttribute('aria-label', m.tMore || 'More');
      minus.addEventListener('click', function () {
        var cur = chosen[id] || 0;
        var next = cur - (m.step || 1);
        if (next < (m.min || 1)) { delete chosen[id]; onZero(); return; }
        chosen[id] = next; repaint();
      });
      plus.addEventListener('click', function () {
        chosen[id] = (chosen[id] || 0) + (chosen[id] ? (m.step || 1) : (m.min || 1));
        repaint();
      });
      field.addEventListener('input', function () {
        var n = parseInt(field.value, 10);
        if (!(n > 0) || roundUpTo(m, n) !== n) return;   /* not yet a quantity we can sell — wait for blur */
        chosen[id] = n; repaint();
      });
      field.addEventListener('blur', function () {
        var n = parseInt(field.value, 10);
        if (isNaN(n)) n = chosen[id] || 0;
        if (n <= 0) {
          /* focus has already left the field by the time blur runs, so tell
             paintPanel this closing came from inside the card */
          if (chosen[id]) { focusLeftCard = true; delete chosen[id]; onZero(); } else field.value = '0';
          return;
        }
        chosen[id] = roundUpTo(m, n);
        field.value = String(chosen[id]);
        repaint();
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); field.blur(); }
      });
      st.appendChild(minus); st.appendChild(field); st.appendChild(plus);
      st.__wbOut = field;
      return st;
    }

    function viewLink(url) {
      var a = el('a', 'wb-aop__view', tView + ' ›');
      a.href = url; a.target = '_blank'; a.rel = 'noopener';
      if (tNewWin) a.appendChild(el('span', 'visually-hidden', ' ' + tNewWin));
      return a;
    }

    /* A plain add-on: one row. */
    function row(m) {
      var id = m.id;
      var li = el('li', 'wb-aop__row');
      li.setAttribute('data-variant', id);
      var media = el('span', 'wb-aop__img');
      if (m.img) { var im = document.createElement('img'); im.src = m.img; im.alt = ''; media.appendChild(im); }
      li.appendChild(media);
      var body = el('div', 'wb-aop__b');
      body.appendChild(el('span', 'wb-aop__t', m.title));
      if (m.reason) body.appendChild(el('span', 'wb-aop__w', m.reason));
      if (m.url && tView) body.appendChild(viewLink(m.url));
      li.appendChild(body);
      var right = el('div', 'wb-aop__r');
      right.appendChild(el('span', 'wb-aop__p', '+' + m.money));
      var st = stepper(m, repaint);
      right.appendChild(st);
      var rm = el('button', 'wb-aop__rm', tRemove); rm.type = 'button';
      rm.addEventListener('click', function () { clearTile(id); repaint(); });
      right.appendChild(rm);
      li.appendChild(right);
      li.__wbRefresh = function () {
        if (document.activeElement !== st.__wbOut) st.__wbOut.value = String(chosen[id] || 0);
      };
      return li;
    }

    /* A group: one card, one row PER SIZE, every size visible with its own
       stepper (Owen, 2026-09-12, after the kit builder's row list). Seven
       regulars is Single 1 + 6 pack 1. A size at 0 is shown, not hidden, so
       adding a second size is one tap on its +. Zeroing every size closes the
       card and unticks the tile. */
    function groupCard(key) {
      var g = groups[key];
      var li = el('li', 'wb-aop__row wb-aop__row--group');
      li.setAttribute('data-group', key);

      var head = el('div', 'wb-aop__gh');
      var hb = el('div', 'wb-aop__b');
      hb.appendChild(el('span', 'wb-aop__t', g.name));
      var reason = '';
      for (var i = 0; i < g.members.length; i++) if (g.members[i].reason) { reason = g.members[i].reason; break; }
      if (reason) hb.appendChild(el('span', 'wb-aop__w', reason));
      var def = cat[g.def] || g.members[0];
      if (def && def.url && tView) hb.appendChild(viewLink(def.url));
      head.appendChild(hb);
      var rm = el('button', 'wb-aop__rm', tRemove); rm.type = 'button';
      rm.addEventListener('click', function () { clearTile(key); repaint(); });
      head.appendChild(rm);
      li.appendChild(head);

      var sizes = el('ul', 'wb-aop__sizes');
      var refreshers = [];
      for (var j = 0; j < g.members.length; j++) {
        (function (m) {
          var s = el('li', 'wb-aop__size' + (chosen[m.id] ? ' is-on' : ''));
          var media = el('span', 'wb-aop__simg');
          if (m.img) { var im = document.createElement('img'); im.src = m.img; im.alt = ''; media.appendChild(im); }
          s.appendChild(media);
          var sb = el('div', 'wb-aop__sb');
          sb.appendChild(el('span', 'wb-aop__slabel', m.label));
          sb.appendChild(el('span', 'wb-aop__seach', tEach.replace('#', m.money)));
          s.appendChild(sb);
          var st = stepper(m, repaint);
          s.appendChild(st);
          var totalEl = el('span', 'wb-aop__stotal', '');
          s.appendChild(totalEl);
          var refresh = function () {
            var n = chosen[m.id] || 0;
            s.classList.toggle('is-on', n > 0);
            if (document.activeElement !== st.__wbOut) st.__wbOut.value = String(n);
            totalEl.textContent = n ? '+' + moneyLike(m.money, m.price * n) : '';
          };
          refresh();
          refreshers.push(refresh);
          sizes.appendChild(s);
        })(g.members[j]);
      }
      li.appendChild(sizes);
      li.__wbRefresh = function () { for (var r = 0; r < refreshers.length; r++) refreshers[r](); };
      return li;
    }

    /* Format cents in the shape of a money sample from Liquid ("$1.95" ->
       "$7.95"). Only the digits move; symbol and separators come from the
       sample, so this never invents a currency format. */
    function moneyLike(sample, cents) {
      var n = (cents / 100).toFixed(2);
      var dec = sample.indexOf(',') > sample.indexOf('.') && /\d,\d\d$/.test(sample) ? ',' : '.';
      var num = dec === ',' ? n.replace('.', ',') : n;
      return sample.replace(/[\d.,]+/, num);
    }

    var inner = panel.querySelector('.wb-aopanel__in');
    function fit(open, after) {
      if (!inner) return;
      var dur = parseFloat(getComputedStyle(inner).transitionDuration) || 0;
      var from = inner.offsetHeight;
      var to = open ? list.scrollHeight : 0;
      if (!dur || from === to) {
        inner.style.height = open ? 'auto' : '0px';
        if (after) after();
        return;
      }
      inner.style.height = from + 'px';
      void inner.offsetHeight;
      inner.style.height = to + 'px';
      var fired = false;
      var done = function (e) {
        if (e && e.target !== inner) return;
        if (fired) return;
        fired = true;
        inner.removeEventListener('transitionend', done);
        if (open) inner.style.height = 'auto';
        if (after) after();
      };
      inner.addEventListener('transitionend', done);
      setTimeout(done, dur * 1000 + 60);
    }

    /* The card opens UNDER the strip, which on most screens is at the fold —
       the very complaint that started this. Once the height animation lands,
       lift the page just enough that the whole card is on screen. Three
       pieces of the theme's chrome sit in the way (all found in review):
       - the sticky buy bar slides in when the Add to Cart button leaves
         through the TOP (wb-product.js: cta.bottom <= 0). If the lift would
         park the button in the band behind the pinned header instead
         (0 < bottom <= header), it is hidden AND there is no bar — so push
         on until it really is out, then leave room for the bar;
       - the back-to-top disc (fixed, bottom-right, shown once scrollY >
         innerHeight; higher when the bar is up) lands exactly on a card's
         Remove button — clear it too;
       - a card taller than what is left never scrolls its own top under the
         header: keep the card's header row on screen and let the bottom
         overflow (the user can scroll; the tiles have already done their job). */
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function pinnedHeader() {
      var cs = getComputedStyle(document.documentElement);
      var h = parseFloat(cs.getPropertyValue('--wb-header-h')) || 88;
      if (document.documentElement.classList.contains('header-search-collapsed')) {
        h -= parseFloat(cs.getPropertyValue('--search-row-height')) || 0;
      }
      return Math.max(h, 0);
    }
    function revealCard() {
      var card = list.firstElementChild;
      if (!card) return;
      var vh = window.innerHeight, r = card.getBoundingClientRect();
      var over = r.bottom + 12 - vh;
      if (over <= 0) return;
      var headH = pinnedHeader();
      var bar = document.querySelector('[data-wb-buybar]');
      var cta = ctaText ? ctaText.closest('button') : null;
      var ctaBottom = cta ? cta.getBoundingClientRect().bottom : -1;
      var barShows = document.body.classList.contains('wb-show-buybar') || (ctaBottom - over <= headH);
      var reserve = 0;
      if (bar && barShows) {
        if (ctaBottom - over > 0) over = ctaBottom;      /* all the way out, so the bar really comes */
        reserve += bar.getBoundingClientRect().height;
      }
      var backtop = document.querySelector('.wb-backtop');
      if (backtop && window.scrollY + over > vh) {
        var bt = backtop.getBoundingClientRect();
        reserve += bt.height + Math.max(vh - bt.bottom, 0) + 8;   /* disc + its bottom offset */
      }
      over = Math.max(over, r.bottom + 12 + reserve - vh);
      over = Math.min(over, r.top - headH - 8);            /* never under the header */
      if (over <= 0) return;
      window.scrollBy({ top: over, behavior: reduced ? 'auto' : 'smooth' });
    }

    /* The panel holds the ACTIVE tile's card and nothing else. A card whose
       last unit was stepped to zero closes the panel; the other ticked tiles
       keep their badges and come back with a tap. */
    var painted = null;                     // key of the card in the DOM right now
    var focusLeftCard = false;              // a typed 0 blurred out of the card just now
    function paintPanel(reveal) {
      if (active !== null && tileUnits(active) === 0) active = null;
      var open = active !== null;
      var card = list.firstElementChild;
      /* same card, new numbers: patch it. A rebuild threw the focused + away
         (keyboard users pressed Enter into <body>) and re-read the whole card
         to a screen reader on every press. */
      if (open && painted === active && card && card.__wbRefresh) { card.__wbRefresh(); return; }
      var focusInside = list.contains(document.activeElement) || focusLeftCard;
      focusLeftCard = false;
      var was = painted;
      list.replaceChildren();
      painted = open ? active : null;
      if (open) list.appendChild(groups[active] ? groupCard(active) : row(cat[active]));
      else if (focusInside && was !== null) {
        var back = tileButton(was);
        if (back) back.focus({ preventScroll: true });
      }
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      fit(open, open && reveal ? revealCard : null);
    }

    function repaint(reveal) { paintPanel(reveal); paintTiles(); paintCount(); paintCta(); }

    /* tile tap, in words: "tap a tile to see it; tap the tile you are looking
       at to take it out." An unticked tile is ticked (its default member for
       a group) and its card opens; a ticked tile whose card is closed opens
       it, badge intact; the tile whose card is open is cleared — so the quick
       tap-tap of the old toggle still adds and removes. */
    grid.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-wb-ao-add]') : null;
      if (!b || !grid.contains(b) || block.classList.contains('is-blocked')) return;
      var tile = b.closest('[data-wb-ao]');
      var key = tileKey(tile);
      if (!key) return;
      var reveal = false;
      if (tileUnits(key) === 0) {
        var g = groups[key];
        var d = g ? (cat[g.def] || g.members[0]) : cat[key];
        if (!d) return;
        chosen[d.id] = d.min || 1;
        active = key; reveal = true;
      } else if (active === key) {
        clearTile(key);
      } else {
        active = key; reveal = true;
      }
      repaint(reveal);
    });

    /* hover marquee — only when the title actually overflows */
    var MARQ_PX_PER_S = 38;
    var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
    grid.addEventListener('mouseover', function (e) {
      if (!canHover) return;   /* a tap fires a synthetic mouseover and never a mouseout */
      var tile = e.target.closest ? e.target.closest('[data-wb-ao]') : null;
      if (!tile || tile.classList.contains('is-marq')) return;
      var name = tile.querySelector('.wb-ao__name'), inner2 = tile.querySelector('.wb-ao__name-in');
      if (!name || !inner2 || name.scrollWidth <= name.clientWidth + 1) return;
      tile.classList.add('is-marq');
      var lap = inner2.scrollWidth / 2;
      tile.style.setProperty('--wb-marq-dur', (lap / MARQ_PX_PER_S).toFixed(2) + 's');
    });
    grid.addEventListener('mouseout', function (e) {
      var tile = e.target.closest ? e.target.closest('[data-wb-ao]') : null;
      if (!tile) return;
      var to = e.relatedTarget;
      if (to && tile.contains(to)) return;
      tile.classList.remove('is-marq');
      tile.style.removeProperty('--wb-marq-dur');
    });

    /* page arrows — the strip shows whole tiles only (CSS bands), so a page
       is `per` tiles: floor((port + gap) / pitch). Paging is by TILE INDEX
       from a remembered target, not a relative scrollBy: scrollBy resolves
       against the mid-glide position, so a quick second click compounded
       into the snap and landed off-page (review). Prev from the clamped
       last page returns to the page boundary before it, not "one page back
       from wherever the clamp stopped". aria-disabled, not disabled — a
       button that disables itself under keyboard focus drops focus to body.
       Offsets are signed by writing direction (scrollLeft runs negative in
       an RTL scroller) and clamped, so the iOS rubber-band cannot flicker
       Prev on at the start edge. */
    var navBox = block.querySelector('[data-wb-ao-nav]');
    var prevBtn = block.querySelector('[data-wb-ao-prev]');
    var nextBtn = block.querySelector('[data-wb-ao-next]');
    var target = null, settle = null;
    function stripGap() { return parseFloat(getComputedStyle(grid).columnGap) || 9; }
    function isRtl() { return getComputedStyle(grid).direction === 'rtl'; }
    function offset() {
      var max = grid.scrollWidth - grid.clientWidth;
      var x = isRtl() ? -grid.scrollLeft : grid.scrollLeft;
      return Math.min(Math.max(x, 0), Math.max(max, 0));
    }
    function setState(btn, off) {
      if (btn) btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    }
    function paintNav() {
      if (!navBox) return;
      var max = grid.scrollWidth - grid.clientWidth, x = offset();
      navBox.hidden = max <= 1;
      setState(prevBtn, x <= 1);
      setState(nextBtn, x >= max - 1);
      if (target !== null && Math.abs(x - target) < 1) target = null;
    }
    function page(dir, btn) {
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var first = grid.firstElementChild, g = stripGap();
      var pitch = first ? first.getBoundingClientRect().width + g : 0;
      if (!pitch) return;
      var per = Math.max(1, Math.floor((grid.clientWidth + g) / pitch + 0.05));
      var max = Math.max(grid.scrollWidth - grid.clientWidth, 0);
      var idx = Math.round((target !== null ? target : offset()) / pitch);
      var to;
      if (dir > 0) to = (Math.floor(idx / per) + 1) * per;
      else if (target === null && offset() >= max - 1) to = Math.floor((max - 2) / (per * pitch)) * per;
      else to = (Math.ceil(idx / per) - 1) * per;
      target = Math.min(Math.max(to * pitch, 0), max);
      clearTimeout(settle);
      settle = setTimeout(function () { target = null; }, 900);
      grid.scrollTo({ left: isRtl() ? -target : target });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { page(-1, prevBtn); });
    if (nextBtn) nextBtn.addEventListener('click', function () { page(1, nextBtn); });
    grid.addEventListener('scroll', paintNav, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(paintNav).observe(grid); else window.addEventListener('resize', paintNav);
    paintNav();

    form.addEventListener('submit', function (e) {
      if (!units()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      submit();
    }, true);

    if (qtyField) { qtyField.addEventListener('input', paintCta); qtyField.addEventListener('change', paintCta); }
    document.addEventListener('wb:variant:change', function () {
      if (!ctaText) return;
      if (!units()) { ctaBase = ctaText.textContent.trim(); return; }
      paintCta();
    });

    function submit() {
      var cta = form.querySelector('[data-wb-cta]');
      if (cta) { cta.disabled = true; cta.setAttribute('aria-busy', 'true'); }
      var gid = groupId();
      var idField = form.querySelector('[name="id"]');
      var parentId = idField && idField.value;
      if (!parentId) { if (cta) cta.disabled = false; return; }

      var items = [{ id: parentId, quantity: parentQty(), properties: { _addon_group: gid } }];
      var pos = 0;
      for (var k in chosen) {
        if (!chosen[k]) continue;
        pos++;
        var line = { id: k, quantity: chosen[k],
          properties: { _source: 'pdp-addon', _addon_group: gid, _addon_of: String(parentId), _addon_pos: String(pos) } };
        if (ADDONS_NESTED) line.parent_id = parentId;
        items.push(line);
      }
      var sections = [];
      document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } }));
      fetch(ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || (res.data && res.data.status)) throw new Error((res.data && res.data.description) || 'add failed');
          for (var k2 in chosen) delete chosen[k2];
          repaint();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        })
        .catch(function (err) {
          rollback(gid).then(function () {
            var box = form.querySelector('.product-form__error-message');
            if (box) { box.textContent = err.message; box.hidden = false; }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
        })
        .then(function () { if (cta) { cta.disabled = false; cta.removeAttribute('aria-busy'); } });
    }

    function rollback(gid) {
      return fetch(CART, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {}, found = 0;
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (it.properties && it.properties._addon_group === gid) { updates[it.key] = 0; found++; }
          }
          if (!found) return null;
          return fetch(UPDATE, { method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({ updates: updates }) });
        })
        .catch(function () { return null; });
    }

    repaint();
    stampExposure();

    function stampExposure() {
      if (block.getAttribute('data-exposed') === '1') return;
      block.setAttribute('data-exposed', '1');
      fetch((routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _addon_exposed: '1' } })
      }).catch(function () {});
    }
  }

  function boot() {
    var blocks = document.querySelectorAll('[data-wb-addons]');
    for (var i = 0; i < blocks.length; i++) init(blocks[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
